import { render, staticRenderFns } from "./default.vue?vue&type=template&id=647ac772&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=647ac772&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrawerMenu: require('/home/vsts/work/1/s/components/DrawerMenu.vue').default,ReleaseNoteModal: require('/home/vsts/work/1/s/components/ReleaseNoteModal.vue').default})
